import pica from "pica";

export function resizeImage(imageUrl, data, imageOptions) {
  return new Promise((resolve, reject) => {
    const orientationCallback = (exifOrientation) => {
      const rotationDegrees = _getRotationDegrees(exifOrientation);

      let img = new Image();

      img.onload = function () {
        if (
          img.width < imageOptions.maxSide &&
          img.height < imageOptions.maxSide
        ) {
          return resolve(data);
        }

        _rotateAndResize(
          imageUrl,
          img,
          rotationDegrees,
          imageOptions,
          resolve,
          reject
        );
      };
      img.onerror = function () {
        reject(new Error("error loading image"));
      };

      const blob = new Blob([data], { type: imageOptions.contentType });
      let urlCreator = window.URL || window.webkitURL;
      img.src = urlCreator.createObjectURL(blob);
    };

    _getOrientation(data, orientationCallback);
  });
}

function _getRotationDegrees(exifOrientation) {
  switch (exifOrientation) {
    case 3:
    case 4:
      return 180;
    case 5:
    case 6:
      return 90;
    case 7:
    case 8:
      return 270;
    default:
      return 0;
  }
}

function _rotateAndResize(
  imageUrl,
  img,
  rotationDegrees,
  imageOptions,
  resolve,
  reject
) {
  if (rotationDegrees === 0) {
    return _resize(imageUrl, imageOptions, img, resolve, reject);
  }

  const rotatedCanvas = document.createElement("canvas");
  _setRotationCanvasWidthAndHeight(rotationDegrees, rotatedCanvas, img);
  _drawRotated(img, rotatedCanvas, rotationDegrees);
  const thePica = pica();
  thePica.toBlob(rotatedCanvas, "image/jpeg").then((blob) => {
    let rotatedImage = new Image();

    rotatedImage.onload = function () {
      _resize(imageUrl, imageOptions, rotatedImage, resolve, reject);
    };
    rotatedImage.onerror = function () {
      reject(new Error("error rotating image"));
    };

    let urlCreator = window.URL || window.webkitURL;
    rotatedImage.src = urlCreator.createObjectURL(blob);
  });
}

function _setRotationCanvasWidthAndHeight(rotationDegrees, rotatedCanvas, img) {
  if (rotationDegrees === 90 || rotationDegrees === 270) {
    // noinspection JSSuspiciousNameCombination
    rotatedCanvas.width = img.height;
    // noinspection JSSuspiciousNameCombination
    rotatedCanvas.height = img.width;
  } else {
    rotatedCanvas.width = img.width;
    rotatedCanvas.height = img.height;
  }
}

function _resize(imageUrl, imageOptions, img, resolve, reject) {
  const resizedCanvas = document.createElement("canvas");
  if (img.width > img.height) {
    resizedCanvas.width = imageOptions.maxSide;
    resizedCanvas.height = _calculateHeightPreservingAspectRatio(
      imageOptions.maxSide,
      img
    );
  } else {
    resizedCanvas.width = _calculateWidthPreservingAspectRatio(
      imageOptions.maxSide,
      img
    );
    resizedCanvas.height = imageOptions.maxSide;
  }
  const thePica = pica();
  thePica
    .resize(img, resizedCanvas)
    .then((result) => thePica.toBlob(result, "image/jpeg", 0.9))
    .then((blob) => resolve(blob))
    .catch((error) => reject(error));
}

function _calculateHeightPreservingAspectRatio(width, img) {
  return (img.height * width) / img.width;
}

function _calculateWidthPreservingAspectRatio(height, img) {
  return (img.width * height) / img.height;
}

function _drawRotated(image, canvas, degrees) {
  let ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.save();
  ctx.translate(canvas.width / 2, canvas.height / 2);
  ctx.rotate((degrees * Math.PI) / 180);
  ctx.drawImage(image, -image.width / 2, -image.height / 2);
  ctx.restore();
}

function _getOrientation(data, callback) {
  let view = new DataView(data.buffer);
  if (view.getUint16(0, false) !== 0xffd8) {
    return callback(-2);
  }
  let length = view.byteLength,
    offset = 2;
  while (offset < length) {
    if (view.getUint16(offset + 2, false) <= 8) return callback(-1);
    let marker = view.getUint16(offset, false);
    offset += 2;
    if (marker === 0xffe1) {
      if (view.getUint32((offset += 2), false) !== 0x45786966) {
        return callback(-1);
      }

      let little = view.getUint16((offset += 6), false) === 0x4949;
      offset += view.getUint32(offset + 4, little);
      let tags = view.getUint16(offset, little);
      offset += 2;
      for (let i = 0; i < tags; i++) {
        if (view.getUint16(offset + i * 12, little) === 0x0112) {
          return callback(view.getUint16(offset + i * 12 + 8, little));
        }
      }
    } else if ((marker & 0xff00) !== 0xff00) {
      break;
    } else {
      offset += view.getUint16(offset, false);
    }
  }
  return callback(-1);
}
